import { useEffect } from 'react';
import { subscribeDocVariablesUpdated } from '../utils/docVariablesEvents';

/**
 * Keep an open doc's local `doc.variables` in sync when Reset Campaign
 * (or its undo) rewrites unlocked values on the server.
 */
export function useDocVariablesLiveSync(docId, setDocVariables) {
  useEffect(() => {
    if (!docId || typeof setDocVariables !== 'function') return undefined;
    return subscribeDocVariablesUpdated(docId, setDocVariables);
  }, [docId, setDocVariables]);
}
